import './about.css'
import {Link} from "react-router-dom";
export default function About(){
    return <>
        <section className="about" >
            <div className="about-container about-layout" >

                <div className="about-text">
                    <h2>PROVENCE PAIE : </h2>
                    <h3>L’Excellence Paie & RH dédiée aux Experts-Comptables</h3>
                    <h5>Simplifiez vos missions sociales avec un partenaire de confiance, né de l’expertise comptable.</h5>

                    <br/>


                    <p>
                        Situé à <strong>Cavaillon</strong>, au cœur de la Provence, <strong>PROVENCE PAIE</strong> est un cabinet de gestion sociale
                        exclusivement dédié à l’accompagnement des cabinets d’expertise comptable. Nous ne sommes pas
                        seulement un prestataire ; nous sommes le prolongement de votre pôle social.
                    </p>
                    <hr/>
                    <h5>Une Vision d’Experts pour des Experts</h5>
                    <p>
                        Fondé par des professionnels du chiffre, PROVENCE PAIE comprend vos enjeux, vos contraintes ...
                    </p>

                    <Link to="/ProvencePaie" className="btn-more">En savoir plus</Link>

                </div>


                <div className="about-image">
                    <div className="image-frame">
                        <img src={`${process.env.PUBLIC_URL}/images/salonDeProvence2.jpg`} alt="Image groupe Provence Compta"/>
                    </div>
                </div>

            </div>
        </section>
    </>
}